/**
 * Helfer fuer Werte aus der Tabelle `system_settings`.
 *
 * Die Spalte `value` ist JSONB. Je nachdem, ob ein Wert per Migration oder
 * ueber das Admin-Panel gesetzt wurde, kommt beim Client eine Zahl (25) oder
 * ein String ("25") an - teilweise sogar mit Anfuehrungszeichen im String
 * selbst. Ein blosser Cast wuerde bei der String-Variante stillschweigend
 * danebengreifen, z. B. bei der Pruefung auf -1 (unbegrenzt).
 *
 * Gegenstueck in der Datenbank: parse_setting_int() in
 * supabase/migrations/160_swipe_limit_enforcement.sql
 */
export function parseSettingNumber(value: unknown, defaultValue: number): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : defaultValue;
  }

  if (typeof value === 'string') {
    // JSONB-Strings koennen die Quotes mitbringen ("\"25\"")
    const parsed = parseInt(value.trim().replace(/^"|"$/g, ''), 10);
    return Number.isNaN(parsed) ? defaultValue : parsed;
  }

  return defaultValue;
}
